module.exports = __webpack_public_path__ + "img/stand.7e96c5b9.png";